import crudmaker from '@/store/crudmaker'
import { apiClient } from '@/client'
import moment from 'moment'
import merge from 'deepmerge'

const defaultParams = {
  from: moment().format('YYYY-MM-DD'),
  to: moment().add(30, 'days').format('YYYY-MM-DD'),
}
const module = 'offdisplays'
let doc = {
  list: {
    name: 'Affichages',
    hasMap: true,
    headers: [
      { label: 'Campagne', value: 'campaign.visual.name' },
      { label: 'Code', value: 'face.full_code' },
      { label: 'Adresse', value: 'face.board.adress' },
      { label: 'District', value: 'face.board.district.name' },
      { label: 'Ville', value: 'face.board.district.city.name' },
      { label: 'Région', value: 'face.board.district.city.region.name' },
      { label: 'Affiché le', value: 'dateUp', orig: 'date_up' },
      { label: 'Par', value: 'user.username' },
      { label: 'Désaffiché le', value: 'dateDown', orig: 'date_down' },
    ],
    actions: [
      { icon: 'search', isFlat: true, dispatch: `${module}/openSearch` },
    ],
    dataActions: [
      { icon: 'visibility', dispatch: `${module}/goTo` },
    ],
    search: [
      { label: 'Du', type: 'date', name: 'from', classes: 'md6' },
      { label: 'Au', type: 'date', name: 'to', classes: 'md6' },
      { label: 'Campagne', type: 'multilist', from: 'name', name: 'visual_id', source: 'visuals', classes: 'md6' },
      { label: 'Client', type: 'multilist', name: 'client_id', from: 'name', source: 'clients', classes: 'md6' },
      { label: 'Région', type: 'multilist', name: 'region_id', from: 'name', source: 'regions', classes: 'md4' },
      { label: 'Ville', type: 'multilist', name: 'city_id', from: 'name', source: 'cities', classes: 'md4' },
      { label: 'District', type: 'multilist', name: 'district_id', from: 'name', source: 'districts', classes: 'md4' },
    ],
  },

  form: {
    name: 'Affichage',
    hasPhoto: true,
    fields: [
      { label: 'Affiché le', type: 'date', name: 'date_up' },
      { label: 'Par', type: 'list', name: 'user_id', from: 'username', source: 'users' },
      { label: 'Désaffiché le', type: 'date', name: 'date_down' },
    ],
  },

  params: {
    fetchAll: {
      include: 'campaign.visual.client,face.board.district.city.region,user',
      ...defaultParams,
    },
    fetchOne: {
      include: 'campaign.visual.client,face.board.district.city.region,user',
    },
  },

  postprocess: item => {
    let dateUp = item.date_up !== null
      ? moment(item.date_up).format('DD/MM/YYYY')
      : ''
    let dateDown = item.date_down !== null
      ? moment(item.date_up).format('DD/MM/YYYY')
      : ''
    let position = item.face
      ? {
        lng: parseFloat(item.face.board.lon),
        lat: parseFloat(item.face.board.lat),
      }
      : {}
    return {
      ...item,
      position,
      dateUp,
      dateDown,
    }
  },
}

const base = crudmaker(module, apiClient, doc)

const custom = {
  state: {
    search: {
      data: defaultParams,
    },
  },
}

export default merge(base, custom)
